import EcoFeeModalContent from './ecoFeeModalContent.component';

export default EcoFeeModalContent;
